
import React from 'react';
import {Link, withRouter} from "react-router-dom";

import AbShortDescription from './AbShortDescription.js'

import {queryApiGet} from '../api.js'
import ErrorComponent from "./error";
import {LocalStorageService} from "../services/localstorage.service";

class VariationsInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingData: true,
            abInfo: null,
            errorOccurred: false,
            accesses: LocalStorageService.getAccesses()
        };
    }

    componentDidMount() {
        this.loadAbInfo()
    }

    setErrorState(errorMessage) {
        this.setState({errorMessages: [...this.state.errorMessages || [], errorMessage]})
    }

    loadAbInfo() {
        queryApiGet(`/api/abInfo?siteId=${this.props.match.params.siteId}`)
        .then(data => {
            this.setState({
                loadingData: false,
                currentAbData: data
            })

            if (this.props.match.params.experimentId === 'replaceWithExperimentId') {
                const currentUrl = window.location.href
                const newValue = this.state.currentAbData.abInfo.id

                const updatedUrl = currentUrl.replace(
                    /replaceWithExperimentId$/,
                    newValue
                )

                window.history.replaceState(null, '', updatedUrl);
            }

        }).catch((e) => this.setErrorState(e))
    }

    render() {
        if (this.state.errorMessages?.length) {
            return (<ErrorComponent errorMessages={this.state.errorMessages} />)
        } else if (this.state.loadingData) {
            return 'Loading a/b data, please wait...'
        }

        const variationInfoRows = this.state.currentAbData.variationsBuildsInfos.map(build => {
            return (
                <VariationBuildInfo key={build.variation} build={build}/>
            )
        })

        return (
            <div>
                <div>
                    Current AB: <AbShortDescription ab={this.state.currentAbData.abInfo}/>
                </div>
                <table border={1} style={{marginTop: '15px'}}>
                    <thead>
                        <tr>
                            <td>
                                Variation
                            </td>
                            <td>
                                Logic
                            </td>
                            <td>
                                Logic Hash
                            </td>
                            <td>
                                Settings
                            </td>
                            <td>
                                Settings Hash
                            </td>
                            <td>
                                Last Deploy At
                            </td>
                            <td>
                                Controls
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                    {variationInfoRows}
                    </tbody>
                </table>
            </div>
        )
    }
}


class VariationBuildInfo extends React.Component {

    constructor() {
        super();

        this.state = {
            accesses: LocalStorageService.getAccesses()
        };
    }

    render () {
        if (this.props.build.type === "dev") {
            return (
                <tr>
                    <td>
                        {this.props.build.variation}
                    </td>
                    <td colSpan={4} style={{textAlign: 'left', color: 'red'}}>
                        DEV BUILD
                    </td>
                    <td style={{textAlign: 'left'}}>
                        {this.props.build.lastModified}
                    </td>
                    <td>
                        --
                    </td>
                </tr>
            )
        }

        return (
            <tr>
                <td>
                    {this.props.build.variation}
                </td>
                <td style={{textAlign: 'left'}}>
                    {this.props.build.version.logic.commitish }
                </td>
                <td>
                    {this.props.build.version.logic.hash.substring(0, 6)}
                </td>
                <td>
                    <a style={{color: '#1a73e8',  textDecoration: 'none', cursor: 'pointer'}} href={`https://github.com/notsy-bv/site_settings/compare/master...${this.props.build.version.settings.hash}`}>{this.props.build.version.settings.commitish}</a>
                </td>
                <td>
                    {this.props.build.version.settings.hash.substring(0, 6)}
                </td>
                <td style={{textAlign: 'left'}}>
                    {this.props.build.lastModified}
                </td>
                <td style={{textAlign: 'left'}}>
                    <ul>
                        {
                        (this.state.accesses.update) && <li>
                            <Link to={`/updateSettings/${this.props.build.siteId}/${this.props.build.variation}`} style={{color: '#ffff99'}}>Update</Link>
                        </li>
                        }
                        <li>
                            <Link to={`/history/${this.props.build.siteId}/${this.props.build.variation}`} style={{color: '#ffff99'}}>History</Link>
                        </li>
                        {
                            this.state.accesses.stopAB && (
                                <li>
                                    <Link to={`/rolloutVariation/${this.props.build.siteId}/${this.props.build.variation}`}  style={{color: '#ffff99'}}>Rollout to 100%</Link>
                                </li>
                            )
                        }
                    </ul>
                </td>
            </tr>
        )
    }
}

export default withRouter(VariationsInfo)
